// pages/QuestionnaireObesityMale.tsx
import QuestionnaireForm from '../components/QuestionnaireForm';
const QuestionnaireObesityMale = () => (
  <QuestionnaireForm questionFile="obesitymale_questions.json" service="obesity_male" />
);
export default QuestionnaireObesityMale;
